import { Component, ElementRef, Input, ViewChild, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { InsuranceHubBaseComponent } from "src/app/cover-folder/Insurance-hub-callback";
import { CommonModule } from "@angular/common";
export interface content {
    id?: string;
    title?: string;
    body?:string;
}
declare var bootstrap: any;
@Component({
  selector: 'app-legal-cover-desktop-benefits-drawer',
  templateUrl: './legalCoverDesktopBenefitsDrawer.component.html',
  styleUrls: ['./legalCoverDesktopBenefitsDrawer.component.css'],
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [CommonModule],  
})
export class LegalCoverDesktopBenefitsDrawerComponent extends InsuranceHubBaseComponent {
    @Input() content: content ={};
    @ViewChild('legalCoverBenefitsDesktopOffcanvas', { static: false }) legalCoverBenefitsDesktopOffcanvas!: ElementRef;


    

 // Public method - can be called from outside components
 public openDrawer(policyDetailResponse: any) {
  this.PolicyDetailResponse = policyDetailResponse;
    this.openOffcanvas();
 }

  openOffcanvas() {

    const htmlDoc=document.getElementsByTagName('html')[0];
    htmlDoc.style.overflow = 'hidden';
    const element = this.legalCoverBenefitsDesktopOffcanvas?.nativeElement;

    if (!element) return;

    let instance = bootstrap.Offcanvas.getInstance(element);
  
     if (!instance) {
    instance = new bootstrap.Offcanvas(element, {
      backdrop: true,
      scroll: false,
      keyboard: true,
    });


      element.addEventListener('hidden.bs.offcanvas', () => {
      document.documentElement.style.overflow = '';
    });
    
}

  instance.show();
}
   closeOffcanvas() {
      const htmlDoc=document.getElementsByTagName('html')[0];
      htmlDoc.style.overflow = ''; 

    const element = this.legalCoverBenefitsDesktopOffcanvas?.nativeElement;
      if (!element) return;
      
    let instance = bootstrap.Offcanvas.getInstance(element);

    if (!instance) {
      instance = new bootstrap.Offcanvas(element, {
        backdrop: true,
        scroll: false,
        keyboard: true,
      });
      element.addEventListener('hidden.bs.offcanvas', () => {
        document.documentElement.style.overflow = '';
      });
  }
  
    instance.hide();
  }



}


